module.exports = "img/close-white.599b6df.png";